<script>
import Anchor from '@theme/components/utils/Wysiwyg/mark/Anchor.vue'
import WysiwygMarks from '~/themes/base/components/utils/Wysiwyg/helpers/WysiwygMarks.vue'

export default {
  name: 'WysiwygMarks',
  components: {
    anchorMark: Anchor,
  },
  extends: WysiwygMarks,
}
</script>
